import { useCreateCompanyLink as useCreateCompanyLinkMutation } from '@api';
import { useNotification } from '@common';
import { CreateCompanyLinkType } from 'src/api/generated/touring/types';

const TRANS_KEY = 'NOTIFICATIONS.CREATE_COMPANY_LINK';

type UseCreateCompanyLinkReturnType = {
  createCompanyLink: (
    data: CreateCompanyLinkType,
    onSuccess?: () => void
  ) => Promise<void>;
};

export const useCreateCompanyLink = (): UseCreateCompanyLinkReturnType => {
  const { mutateAsync } = useCreateCompanyLinkMutation();
  const { showSuccess, showError } = useNotification();

  const createCompanyLink = async (
    data: CreateCompanyLinkType,
    onSuccess?: () => void
  ) => {
    await mutateAsync(
      { data },
      {
        onSuccess: () => {
          showSuccess({
            title: `${TRANS_KEY}.SUCCESS.TITLE`,
            message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
          });
          onSuccess?.();
        },
        onError: (error) => {
          showError({
            title: `${TRANS_KEY}.ERROR.TITLE`,
            message: `${TRANS_KEY}.ERROR.MESSAGE`,
            error,
          });
        },
      }
    );
  };

  return { createCompanyLink };
};
